// const R = require('ramda')

import mergeDeep from 'coact/utils/mergeDeep'
import assocPath from 'coact/utils/assocPath'

import mergeClientRequiredChanges from '../../../utils/schema/mergeClientRequiredChanges.js'

import salesReqs from '../salesReqs.js'
import salesReqItems from '../salesReqItems.js'

const computedItemFields = {
  contents: {
    currentStockQty: { type: 'Number' },
  },
}
const itemSchema = mergeDeep(
  mergeClientRequiredChanges(salesReqItems.schema),
  computedItemFields,
)

const schema = assocPath(
  ['contents', 'items', 'contents', 0],
  itemSchema,
  mergeClientRequiredChanges(salesReqs.schema),
)

export default schema
